/** Apply contrast adjustment to a single channel value. contrast: -100 to 100 */
export function applyContrast(value: number, contrast: number): number {
  const factor = (259 * (contrast + 255)) / (255 * (259 - contrast));
  return factor * (value - 128) + 128;
}
